import { importPageParamsSchemaValidator } from "@grafit/shared/utils/sidebar-url-params-schema";
import { createFileRoute } from "@tanstack/react-router";
import { BidImportPage } from "../../../../../features/bid-import/bid-import-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/import/$subProjectId")({
  component: BidImportPage,
  validateSearch: importPageParamsSchemaValidator,
});
